import {
  BuildingOffice2Icon,
  CalendarDaysIcon,
  TicketIcon,
  AcademicCapIcon,
  ReceiptPercentIcon,
  ShoppingBagIcon,
  BanknotesIcon,
} from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

const navigation: NavigationItem[] = [
  {
    name: "Event Directory",
    href: "/event-registration/events",
    icon: CalendarDaysIcon,
    current: false,
    internalName: "event-directory",
    permissions: ["event-directory"],
  },
  {
    name: "My Registrations",
    href: "/event-registration/my-registrations",
    icon: TicketIcon,
    current: false,
    internalName: "my-registrations",
    permissions: ["my-registrations"],
  },
  {
    name: "Company Registrations",
    href: "/event-registration/company-registrations",
    icon: BuildingOffice2Icon,
    current: false,
    internalName: "company-registrations",
    permissions: ["event-registration-company"],
  },
  {
    name: "My Training History",
    href: "/event-registration/my-training-history",
    icon: AcademicCapIcon,
    current: false,
    internalName: "my-training-history",
    permissions: ["my-training-history"],
  },
  {
    name: "Vouchers",
    href: "/event-registration/my-vouchers",
    icon: ReceiptPercentIcon,
    current: false,
    internalName: "my-vouchers",
    permissions: ["my-vouchers"],
  },
  {
    name: "Product History",
    href: "/event-registration/my-products-history",
    icon: ShoppingBagIcon,
    current: false,
    internalName: "my-products-history",
    permissions: ["my-products-history"],
  },
  {
    name: "Transaction History",
    href: "/event-registration/my-transaction-history",
    icon: BanknotesIcon,
    current: false,
    internalName: "my-transaction-history",
    permissions: ["my-transaction-history"],
  },
];

const eventRegistrationConfig = {
  sectionName: "event-registration",
  defaultRoute: "/event-registration/events",
  navigation,
};

export default eventRegistrationConfig;
